import axios from 'axios'
import { LocalStorage } from '../utils/localstorage'
// import { UserHelper } from '../utils/userHelper'
import https from 'https'

export const http = axios.create({
    baseURL: process.env.REACT_APP_API_ROOTURL,
    timeout: 60000,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
    },
})

// Add a request interceptor
http.interceptors.request.use(
    (config) => {
        config.headers['Access-Control-Allow-Origin'] = 'true'
        const token = LocalStorage.getAccessToken()
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }

        if (process.env.NODE_ENV !== 'production') {
            config.httpsAgent = new https.Agent({
                rejectUnauthorized: true,
            })
        }

        return config
    },
    (error) => {
        Promise.reject(error)
    }
)

// INTERCEPT 401 ERROR (UNAUTHORIZED) AND REDIRECT TO LOGOUT PAGE
http.interceptors.response.use(
    (response) => {
        return response
    },
    (error: any) => {
        // const originalRequest = error.config
        if (
            error.response &&
            error.response.status === 401
            // && !originalRequest._retry
        ) {
            localStorage.clear()
            if ((window as any)?.webkit?.messageHandlers) {
                try {
                    ;(
                        window as any
                    ).webkit.messageHandlers.forceAppLogout.postMessage(
                        'forceAppLogout'
                    )
                } catch (error) {}
            } else {
                // const url = new URL(process.env.DIGITAL_PORTAL_URL)
                const path = window.location.pathname
                const urlParams = new URLSearchParams(window.location.search)
                const isShared = urlParams.get('isShared') === 'true'

                let noncePath = isShared
                    ? path.startsWith('/')
                        ? `?nonce=${path.slice(1)}`
                        : `?nonce=${path}`
                    : ''

                localStorage.setItem('LUX_SMARTLY_nonce', noncePath)

                location.assign(process.env.DIGITAL_PORTAL_URL + '/logout')
                // location.assign(process.env.DIGITAL_PORTAL_URL + '/logout')
                // window.location.href = process.env.DIGITAL_PORTAL_URL + '/logout'
            }
            // do logout
            // originalRequest._retry = true;
            // return http
            //   .post("/auth/refresh/", {
            //     refresh_token: LocalStorage.getRefreshToken(),
            //   })
            //   .then((res) => {
            //     if (res.status === 200) {
            //       if (res.data && res.data.accessToken && res.data.refreshToken)
            //         UserHelper._shared().doLogin(
            //           res.data.accessToken,
            //           res.data.refreshToken
            //         );
            //       // 2) Change Authorization header
            //       //instance.headers.common['Authorization'] = 'Bearer ' + localStorageService.getAccessToken();
            //       // 3) return originalRequest object with Axios.
            //       return http(originalRequest);
            //     }
            //   });
        }

        // return Error object with Promise
        return Promise.reject(error)
    }
)
